export const InfoBlock = ({
  label,
  value,
}: {
  label: string
  value?: string | number
}) => {
  if (!value) return null
  return (
    <div className='grid grid-cols-[auto_1fr] gap-x-4 items-baseline w-full py-3 border-b last:border-0' style={{ borderColor: 'var(--border-color)' }}>
      <span className='text-base font-medium text-right whitespace-nowrap' style={{ color: 'var(--text-secondary)' }}>
        {label}:
      </span>
      <span className='text-base font-semibold text-right leading-relaxed' style={{ color: 'var(--text-primary)' }}>
        {value}
      </span>
    </div>
  )
}
